
import Swiper, { Navigation, Pagination } from 'swiper'
import 'swiper/swiper-bundle.css'
import { nextTick, onMounted, ref, watch, defineComponent, PropType } from 'vue'
import MagazineCard from '@/components/block/MagazineCard.vue'
import { MagazineSpecialRecommendContent } from '@/types/MagazineRecommend'

export default defineComponent({
  name: 'MagazineCardSlider',
  props: {
    items: {
      type: Array as PropType<MagazineSpecialRecommendContent[]>,
      default: () => []
    },
    navigation: {
      type: Array as PropType<string[]>,
      default: () => []
    },
    pagination: {
      type: Array as PropType<string[]>,
      default: () => []
    }
  },
  components: {
    MagazineCard
  },
  setup(props) {
    const visibleClass = (arr: string[]) => ({
      hiddenPc: !arr.includes('pc'),
      hiddenSp: !arr.includes('sp')
    })
    const mySwiper = ref<any>(null)
    watch(
      () => props.items,
      () => {
        nextTick(() => {
          // 1画面で複数使うと配列になるっぽい
          if (Array.isArray(mySwiper.value)) {
            mySwiper.value.forEach((sw: any) => sw.update())
          } else {
            mySwiper.value.update()
          }
        })
      }
    )

    onMounted(() => {
      Swiper.use([Navigation, Pagination])
      mySwiper.value = new Swiper('.swiper-container', {
        breakpoints: {
          900: {
            slidesPerView: 4
          }
        },
        slidesPerView: 1.4,
        spaceBetween: 15,
        pagination: {
          el: '.swiper-pagination',
          clickable: true
        },
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        }
      })
    })
    return {
      visibleClass
    }
  }
})
